define('lq/queryString',[
    'underscore'
], function (_) {
    'use strict';

    var parameters = null;

    var getParametersFromQueryString = function () {
        if (!window.location.search) return {};
        
        var queryString = window.location.search.substr(1).split('&');

        if (!queryString) return {};

        var params = {};
        for (var i = 0; i < queryString.length; ++i) {
            var queryStringPart = queryString[i];
            var splitPosition = queryStringPart.indexOf('=');

            if (splitPosition) {
                var paramName = queryStringPart.substring(0, splitPosition);
                var paramValue = queryStringPart.substring(splitPosition + 1);
                params[paramName] = decodeURIComponent(paramValue.replace(/\+/g, " "));
            }
        }

        return params;
    };

    var readParameters = function () {
        if (!parameters)
            parameters = getParametersFromQueryString();
        return parameters;
    };

    return {
        getParameterNames: function () {
            return _.keys(readParameters());
        },
        getParameters: function() {
            return readParameters();
        },
        getValueOf: function(parameterName) {
            return readParameters()[parameterName];
        }

    };

});
